export default {
  cart: {
    en: 'Shopping cart',
  },
}
